module.exports = __webpack_public_path__ + "static/media/web-design.ce8c6fe0.jpg";